<template>
  <builderall-loader :loading='showLoading'>
    <div v-show="showLoading" class="loader-content"></div>
    <div v-show="!showLoading" class="login-main-wrapper" >
      <div class="login-main-content">
        <div @click="open('https://builderall.com/builderall7')" class="background-img" style="background-image: url('/internacional/public/office6/img/auth/supercharge.jpg')"></div>
        <slot
          name="login-col"
          :classNameLogin="'login-new'"
          :onLoginSubmit="onLoginSubmit"
          :onToggleOfficeButton="onToggleOfficeButton"
        >
          <div>LOGIN</div>
        </slot>
      </div>

      <div id="fb-root"></div> <!-- modal facebook -->
      <span class="copy copy__v2"></span> <!-- just for Clipboard instance -->

    </div>
  </builderall-loader>
</template>

<script>
    export default {
        name: 'lv6-main',
        props: ['view'],
        data: function() {
            return {
                showLoading: true
            }
        },
        methods: {
            callShowLoading(){
                let vm = this
                setTimeout(() => {
                    vm.showLoading = true
                }, 500)
            },
            onLoginSubmit(){
                this.callShowLoading()
            },
            onToggleOfficeButton(type = ''){
                // enable just when page loads
                let types = ['forgot-password', 'change-password'];
                if(types.includes(type)) {
                    this.callShowLoading()
                }
            },
            open(link) {
              window.open(link, "_self")
            }
        },
        mounted: async function() {
            let vm = this
            $(window).on('load', (e) => {
                vm.showLoading = false
            });
        }
    }
</script>

<style scoped lang="scss">
.loader-content {
  width: 100%;
  height: 100vh;
}
.login-main-content {
  min-height: 100vh;
  max-width: 100% !important;
  padding: 0 !important;

  font-weight: 400;
  text-align: left;
  box-sizing: border-box;
  font-style: normal;
  font-size: 14px;
  line-height: 1.15;
  position: relative;
  width: 100%;
  background: #f4f4f4 50%;
  background-size: cover;
  height: 100%;
  .background-img {
    cursor: pointer;
    min-height: 100vh;
    max-width: 100% !important;
    padding: 0 !important;

    font-weight: 400;
    text-align: left;
    box-sizing: border-box;
    font-style: normal;
    font-size: 14px;
    line-height: 1.15;
    position: relative;
    width: 100%;
    background-position: 50%;
    background-size: cover;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/auth/index.vue